import Payments from "../../../../../payments";

export default function EntityPayments() {
  return (
    <div
      className="flex h-full w-full flex-col gap-3 overflow-y-auto rounded-[14px] bg-white p-6"
    >
      <Payments />
    </div>
  );
}
